/** Runtime configuration from build-time env (see .env.example). */
const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim() || '';
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim() || '';

export const config = {
  supabaseUrl: url,
  supabaseAnonKey: anonKey,
  /** Without Supabase settings the app runs in demo mode: data stays on this device. */
  cloud: Boolean(url && anonKey),
  paymentsEnabled: import.meta.env.VITE_PAYMENTS_ENABLED === 'true',
  /** Show "Continue with Google" only after the Google provider is set up in Supabase. */
  googleEnabled: import.meta.env.VITE_GOOGLE_ENABLED === 'true',
  consentVersion: '2026-10-25',
  /** One-time payment, unlocks Premium forever for the account. Server-side price is in supabase/functions/create-checkout. */
  price: { thb: 299 }
} as const;
